import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-fcsc-uploadtool',
  templateUrl: './fcsc-uploadtool.component.html',
  styleUrls: ['./fcsc-uploadtool.component.scss'],
})
export class FcscUploadtoolComponent {
  constructor() {}
}
